import {
  RATE_MY_SERVICE_MODAL_VIEWED,
  RATE_MY_SERVICE_SKIPPED,
  RATE_MY_SERVICE_SUCCESS_INTERACTED,
  RATE_MY_SERVICE_SUCCESS_VIEWED,
} from '../../../constants/ratings'
import { ITrackableServiceRatingAction } from '../../../interfaces/ratings'


export const trackServiceRatingModalViewed = ({
  screen_name = null,
  app_instance = null,
  english_translation_rating_reason = null,
  native_language_rating_reason = null,
  poc_id = null,
  rating_free_text = null,
  rating_given = null,
  ticket_id = null,
  vendorId = null,
  answer_type = null,
  number_of_questions = null,
  question_responses = null,
  rating_type = null,
  entry_method = null,
}): ITrackableServiceRatingAction => ({
  type: RATE_MY_SERVICE_MODAL_VIEWED,
  payload: {
    poc_id,
    vendorId,
    app_instance,
    entry_method,
    screen_name,
    english_translation_rating_reason,
    native_language_rating_reason,
    rating_free_text,
    rating_given,
    ticket_id,
    answer_type,
    question_responses,
    rating_type,
    number_of_questions,
  },
})

export const trackServiceRatingSubmission = ({
  app_instance = null,
  ticket_id = null,
  screen_name = null,
  step_name = null,
  english_translation_rating_reason = null,
  native_language_rating_reason = null,
  rating_free_text = null,
  rating_given = null,
  poc_id = null,
  failure_reason = undefined,
  type,
  vendorId = null,
  answer_type = null,
  number_of_questions = null,
  question_responses = null,
  rating_type = null,
  entry_method = null,
}): ITrackableServiceRatingAction => ({
  type,
  payload: {
    poc_id,
    app_instance,
    entry_method,
    ticket_id,
    step_name,
    screen_name,
    english_translation_rating_reason,
    native_language_rating_reason,
    rating_free_text,
    rating_given,
    failure_reason,
    vendorId,
    answer_type,
    question_responses,
    rating_type,
    number_of_questions,
  },
})

export const trackServiceRatingSuccessViewed = ({
  screen_name = null,
  app_instance = null,
  poc_id = null,
  answer_type = null,
  number_of_questions = null,
  rating_type = null,
  entry_method = null,
}): ITrackableServiceRatingAction => ({
  type: RATE_MY_SERVICE_SUCCESS_VIEWED,
  payload: {
    answer_type,
    app_instance,
    entry_method,
    number_of_questions,
    poc_id,
    rating_type,
    screen_name,
  },
})

export const trackServiceRatingSuccessInteracted = ({
  app_instance = null,
  poc_id = null,
  screen_name = null,
  rating_type = null,
  answer_type = null,
  number_of_questions = null,
  rating_sucess_action = null,
  entry_method = null,
}): ITrackableServiceRatingAction => ({
  type: RATE_MY_SERVICE_SUCCESS_INTERACTED,
  payload: {
    app_instance,
    entry_method,
    poc_id,
    screen_name,
    rating_type,
    answer_type,
    number_of_questions,
    rating_sucess_action,
  },
})

export const trackServiceRatingSkipped = ({
  app_instance = null,
  entry_method = null,
  poc_id = null,
  screen_name = null,
  vendorId = null,
  ticket_id = null,
  rating_type = null,
  answer_type = null,
  number_of_questions = null,
}): ITrackableServiceRatingAction => ({
  type: RATE_MY_SERVICE_SKIPPED,
  payload: {
    app_instance,
    entry_method,
    poc_id,
    screen_name,
    vendorId,
    ticket_id,
    rating_type,
    answer_type,
    number_of_questions,
  },
})
